export default "__VITE_ASSET__84dae568__"